// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"unauthorized_wrapper__78woo","container":"unauthorized_container__2M4dH","header":"unauthorized_header__1n1t_","main":"unauthorized_main__944rB"};